import { ReactNode } from "react";

interface FormProps {
    onSubmit: (e: boolean) => void;
    children: ReactNode;
}


export const DeleteModal = (props: FormProps) => (
    <div className="px-6 py-4">
        <div style={{ textAlign: 'center' }}>
            {props.children}
        </div>

        <br></br>
        <div className="space-y-3">
            <button className="btn bg-red-600 hover:bg-red-800 rounded-lg" onClick={() => props.onSubmit(true)}>Ja</button>
            <button className="btn bg-neutral-500 hover:bg-neutral-600" onClick={() => props.onSubmit(false)}>Abbrechen</button>
        </div>
    </div>
);